document.querySelectorAll('[data-rr-watch-player]').forEach((stage) => {
  const video = stage.querySelector('video');
  const launch = stage.querySelector('.rr-watch__launch');
  if (!video || !launch) return;
  launch.hidden = false;
  launch.addEventListener('click', () => {
    launch.hidden = true;
    video.play().catch(() => { launch.hidden = false; });
  });
  video.addEventListener('play', () => { launch.hidden = true; });
  video.addEventListener('ended', () => { launch.hidden = false; });
});
